// extracted by mini-css-extract-plugin
module.exports = {"timeout_alert":"index_timeout_alert__jsjDz","timeout_content":"index_timeout_content__1K5dp","timeout_text":"index_timeout_text__18QY4","timeout_btn":"index_timeout_btn__3_Xf4"};